import { render } from "./BackgroundImage.vue?vue&type=template&id=2580241a&scoped=true&ts=true"
import script from "./BackgroundImage.vue?vue&type=script&lang=ts"
export * from "./BackgroundImage.vue?vue&type=script&lang=ts"

import "./BackgroundImage.vue?vue&type=style&index=0&id=2580241a&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2580241a"]])

export default __exports__